<div class="grid">
    <div class="col-12">
        <div class="card">
            <div class="formgroup">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <button
                            pButton
                            pRipple
                            routerLink="/rfarias/plano-contas-matriz/inserir"
                            label="Novo"
                            icon="pi pi-plus"
                            class="p-button-outlined mr-2 mb-2"
                        ></button>
                    </div>
                </div>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt2
                [value]="listaPlanoContasAgrupados"
                dataKey="base"
                [expandedRowKeys]="expandedRows"
                responsiveLayout="scroll"
                [rows]="10"
                [paginator]="true"
                styleClass=" p-datatable-sm"
                [loading]="loading"
                [globalFilterFields]="['base']"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <button
                            pButton
                            pRipple
                            pTooltip="Ver detalhado em PDF"
                            [icon]="loadingRelatorio ? 'pi pi-spin pi-spinner' : 'pi pi-file-pdf'"
                            [disabled]="loadingRelatorio"
                            class="p-button-outlined"
                            (click)="obterRelatorio()"
                        ></button>
                        <div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input
                                    pInputText
                                    type="text"
                                    #filter
                                    (input)="buscar(dt2, $event)"
                                    placeholder="Buscar"
                                    class="w-full"
                                />
                            </span>
                            <span class="ml-2">
                                <button
                                    pButton
                                    class="p-button-outlined"
                                    icon="pi pi-filter-slash"
                                    pTooltip="Limpar Filtros"
                                    (click)="limpar(dt2)"
                                ></button>
                            </span>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="body" let-item let-expanded="expanded">
                    <tr>
                        <td style="width: 3rem">
                            <button
                                type="button"
                                pButton
                                pRipple
                                [pRowToggler]="item"
                                class="p-button-text p-button-rounded p-button-plain"
                                style="box-shadow: none"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            ></button>
                        </td>
                        <td style="min-width: 12rem" class="text-lg font-semibold">
                            {{ item.base }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-item>
                    <tr>
                        <td colspan="7">
                            <div class="px-6">
                                <p-table
                                    [value]="item.tipos"
                                    dataKey="tipo"
                                    responsiveLayout="scroll"
                                >
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th style="width: 3rem"></th>
                                            <th pSortableColumn="tipo">
                                                Tipo
                                                <p-sortIcon field="tipo"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template
                                        pTemplate="body"
                                        let-tipo
                                        let-expandedTipo="expanded"
                                    >
                                        <tr>
                                            <td>
                                                <button
                                                    type="button"
                                                    pButton
                                                    pRipple
                                                    [pRowToggler]="tipo"
                                                    class="p-button-text p-button-rounded p-button-plain"
                                                    style="box-shadow: none"
                                                    [icon]="
                                                        expandedTipo
                                                            ? 'pi pi-chevron-down'
                                                            : 'pi pi-chevron-right'
                                                    "
                                                ></button>
                                            </td>

                                            <td
                                                style="min-width: 12rem"
                                                class="text-lg font-semibold"
                                            >
                                                {{ tipo.tipo }}
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="rowexpansion" let-tipo>
                                        <tr>
                                            <td colspan="7">
                                                <div class="px-6">
                                                    <p-table
                                                        [value]="tipo.grupos"
                                                        dataKey="id"
                                                        responsiveLayout="scroll"
                                                    >
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th style="width: 3rem"></th>
                                                                <th pSortableColumn="descricao">
                                                                    Grupo
                                                                    <p-sortIcon
                                                                        field="descricao"
                                                                    ></p-sortIcon>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template
                                                            pTemplate="body"
                                                            let-grupo
                                                            let-expandedGrupo="expanded"
                                                        >
                                                            <tr>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        pButton
                                                                        pRipple
                                                                        [pRowToggler]="grupo"
                                                                        class="p-button-text p-button-rounded p-button-plain"
                                                                        style="box-shadow: none"
                                                                        [icon]="
                                                                            expandedGrupo
                                                                                ? 'pi pi-chevron-down'
                                                                                : 'pi pi-chevron-right'
                                                                        "
                                                                    ></button>
                                                                </td>

                                                                <td
                                                                    style="min-width: 12rem"
                                                                    class="text-lg font-semibold"
                                                                >
                                                                    {{ grupo.descricao }}
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template
                                                            pTemplate="rowexpansion"
                                                            let-grupo
                                                        >
                                                            <tr>
                                                                <td colspan="7">
                                                                    <div class="px-6">
                                                                        <p-table
                                                                            [value]="grupo.contas"
                                                                            dataKey="codigo"
                                                                            responsiveLayout="scroll"
                                                                        >
                                                                            <ng-template
                                                                                pTemplate="header"
                                                                            >
                                                                                <tr>
                                                                                    <th
                                                                                        pSortableColumn="id"
                                                                                    >
                                                                                        Código
                                                                                        <p-sortIcon
                                                                                            field="price"
                                                                                        ></p-sortIcon>
                                                                                    </th>
                                                                                    <th
                                                                                        pSortableColumn="customer"
                                                                                    >
                                                                                        Descrição
                                                                                        <p-sortIcon
                                                                                            field="customer"
                                                                                        ></p-sortIcon>
                                                                                    </th>
                                                                                    <th
                                                                                        pSortableColumn="date"
                                                                                    >
                                                                                        DRE
                                                                                        <p-sortIcon
                                                                                            field="date"
                                                                                        ></p-sortIcon>
                                                                                    </th>
                                                                                    <th
                                                                                        style="
                                                                                            width: 4rem;
                                                                                            text-align: center;
                                                                                        "
                                                                                    >
                                                                                        Ações
                                                                                    </th>
                                                                                </tr>
                                                                            </ng-template>
                                                                            <ng-template
                                                                                pTemplate="body"
                                                                                let-conta
                                                                            >
                                                                                <tr>
                                                                                    <td>
                                                                                        <span
                                                                                            class="font-italic"
                                                                                        >
                                                                                            {{
                                                                                                conta.codigo
                                                                                            }}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span
                                                                                            class="font-italic"
                                                                                        >
                                                                                            {{
                                                                                                conta.descricao
                                                                                            }}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span
                                                                                            class="font-italic"
                                                                                        >
                                                                                            {{
                                                                                                conta.dre
                                                                                            }}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="flex"
                                                                                        >
                                                                                            <button
                                                                                                pButton
                                                                                                pRipple
                                                                                                pTooltip="Editar"
                                                                                                (click)="
                                                                                                    editarPlanoContaMatriz(
                                                                                                        conta.codigo
                                                                                                    )
                                                                                                "
                                                                                                icon="pi pi-pencil"
                                                                                                class="p-button-success mr-2 mb-2"
                                                                                            ></button>
                                                                                            <button
                                                                                                pButton
                                                                                                pRipple
                                                                                                pTooltip="Excluir"
                                                                                                (click)="
                                                                                                    excluirPlanoContaMatriz(
                                                                                                        conta.codigo
                                                                                                    )
                                                                                                "
                                                                                                icon="pi pi-trash"
                                                                                                class="p-button-danger mr-2 mb-2 sm"
                                                                                            ></button>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            </ng-template>
                                                                            <ng-template
                                                                                pTemplate="emptymessage"
                                                                            >
                                                                                <tr>
                                                                                    <td colspan="6">
                                                                                        Nenhum
                                                                                        registro
                                                                                        encontrado.
                                                                                    </td>
                                                                                </tr>
                                                                            </ng-template>
                                                                        </p-table>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="emptymessage">
                                                            <tr>
                                                                <td colspan="6">
                                                                    Nenhum registro encontrado.
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="6">Nenhum registro encontrado.</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
        </div>
    </div>
</div>
